<template>
  <!--
      [ 간격 옵션 : spacing--sm ]
      spacing--sm
      spacing--md
      spacing--lg

      [ 폰트크기 옵션 : font--sm ]
      font--sm
      font--md
      font--lg

      [ 보더 옵션 : 없음 ]
      .style--border
      .style--bg
    -->
  <table class="table OPTION style--border spacing--lg font--md">
    <thead>
      <tr>
        <th
          class="lv--1 w--sm td--checkbox"
          v-if="checkbox"
        >
          <form-checkbox
            v-model="selectedAll"
            @change="$emit('selectAll')"
            :true-value="true"
            :false-value="false"
          ></form-checkbox>
        </th>
        <th class="lv--5 w--sm td--number">번호</th>
        <th
          class="lv--1 w--sm td--question"
          v-if="answerFlag"
        >답변</th>
        <th class="lv--1 text--left td--title">제목</th>
        <th class="lv--1 w--md td--user-name">작성자</th>
        <th
          class="lv--5 w--md td--file"
          v-if="downloadFlag"
        >첨부파일</th>
        <th class="lv--2 w--lg td--date">작성일</th>
        <th class="lv--5 w--md td--counter">조회수</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="row in rows"
        :key="row.seq"
      >
        <td
          class="lv--1 w--sm td--checkbox"
          v-if="checkbox"
        >
          <form-checkbox
            v-model="row.selected"
            :true-value="true"
            :false-value="false"
          ></form-checkbox>
          <!-- <p v-else-if="currentRow === row.seq">></p> -->

        </td>
        <td class="lv--5 w--sm td--number">{{row.num}}</td>
        <td
          class="lv--1 w--sm td--question"
          v-if="answerFlag"
        >
          <span
            class="stamp stamp--sm blue text--white text--middle"
            v-if="row.answer"
          >답변</span>
          <span
            class="stamp stamp--sm gray lighten--4 text--white text--middle"
            v-else
          >대기</span>

        </td>
        <td class="lv--1 td--title">
          <a @click="goView(row.seq)">
            <span
              class="stamp stamp--sm blue text--white text--middle"
              v-if="row.noticeFlag === 'Y'"
            >공지</span>
            <span
              class="stamp stamp--sm gray lighten-1 text--white text--middle"
              v-if="row.secretFlag === 'Y'"
            >비밀글</span>
            <span
              class="stamp stamp--sm blue text--white text--middle"
              v-if="filterFlag"
            >{{row.filter}}</span>

            {{row.title}}
          </a>
        </td>
        <td class="lv--1 w--md td--user-name">{{row.userName}}</td>
        <td
          class="lv--5 w--md td--file"
          v-if="downloadFlag"
        >
          <span
            class="stamp stamp--sm blue text--white text--middle"
            v-if="row.files.length > 0"
            @click="$utils.download({url: `/api/boards/${$route.params.boardId}/files/${row.uuid}/${row.files[0].fileName}`, query: {}, filename: row.files[0].originalName})"
          >download</span>
        </td>
        <td class="lv--2 w--lg text--center td--date">{{row.createdAt | dateFmt8}}</td>
        <td class="lv--5 w--md td--counter">{{row.views}}</td>
      </tr>
    </tbody>
  </table>

</template>

<script>

import boardMeta from '../js/boardMeta'

export default {
  mixins: [boardMeta],
  props: {
    rows: { type: Array, required: true },
    goView: { type: Function, required: true },
    checkbox: { type: Boolean, default: false },
    currentRow: { type: Number, default: -1 },
    selected: { type: Boolean, default: false }
    // useOptions: { type: Object }
  },
  data () {
    return {
      selectedAll: false
    }
  },
  watch: {
    selected () {
      this.selectedAll = this.selected
    }
  },
  computed: {
    // answerFlag () {
    //   console.log('this.useOptions', this.useOptions)
    //   return !!(this.useOptions.hasOwnProperty('answerFlag') && this.useOptions.answerFlag === 'Y')
    // },
    // filterFlag () {
    //   return !!(this.useOptions.filterFlag && this.useOptions.filterFlag === 'Y')
    // },
    // downloadFlag () {
    //   return !!(this.useOptions.downloadFlag && this.useOptions.downloadFlag === 'Y')
    // }
  },
  components: {
    FormCheckbox: () => import('@/component/ui2/form/FormCheckbox')
  }
}
</script>


<!-- 
  <table class="table table--hover">
    <colgroup>
      <col class="w--5%">
      <col class="w--10%">
      <col class="w--35%">
      <col class="w--20%">
      <col class="w--10%">
      <col class="w--10%">
      <col class="w--10%">
    </colgroup>
    <thead>
      <tr>
        <th>
          <checkbox
            v-if="checkbox"
            v-model="selected"
            @change="all"
            :true-value="true"
            :false-value="false"
          ></checkbox>
        </th>
        <th>seq</th>
        <th>제목</th>
        <th>작성자</th>
        <th class="text--center">작성일</th>
        <th>조회수</th>
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="row in rows"
        :key="row.seq"
      >
        <td>
          <checkbox
            v-if="checkbox"
            v-model="row.selected"
            :true-value="true"
            :false-value="false"
          ></checkbox>
          <p v-else-if="currentRow === row.seq">></p>
        </td>
        <td>
          {{row.seq}}
          <span v-if="row.noticeFlag === 'Y'">공지</span>
          <span v-if="row.secretFlag === 'Y'">비밀글</span>
        </td>
        <td>
          <a @click="goView(row.seq)">{{row.title}}</a>
        </td>
        <td>{{row.userName}}</td>
        <td class="text--center">{{row.createdAt | dateFmt14}}</td>
        <td>{{row.views}}</td>
      </tr>
    </tbody>
  </table>
-->
